'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;
function init(superagent) {
    if (!superagent || !superagent.Request) {
        return;
    }

    var end = superagent.Request.prototype.end;
    superagent.Request.prototype.end = function (cb) {
        var startTime = Date.now();
        return end.call(this, function (err, res) {
            if (typeof cb !== 'function') {
                return;
            }
            if (err) {
                return cb(err, null);
            }
            var endTime = Date.now();
            res.metrics = {
                startTime: startTime,
                endTime: endTime,
                duration: endTime - startTime
            };
            cb(err, res);
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/superagent-metrics/lib/index.js
// module id = 753
// module chunks = 0